import {
  createRestyleComponent,
  createVariant,
  VariantProps,
} from "@shopify/restyle";
import { Theme } from "app/Theme/Theme";
import React from "react";
import { TextInput } from "react-native";
import { Box } from "../../index";

const InputTextContainer = createRestyleComponent<
  VariantProps<Theme, "textVariants"> & React.ComponentProps<typeof Box>,
  Theme
>([createVariant({ themeKey: "textVariants" })], Box);

export interface IMainTextInputProps {
  placeholderTextInput?: string;
  multiline?: boolean;
  maxLength?: number;
  placeholderText?: string;
  inputText?: string;
  onTextChange: (text: string) => void;
  round?: boolean;
}

function MainTextInput({
  inputText = "",
  placeholderTextInput = "",
  multiline = false,
  maxLength = undefined,
  onTextChange,
  round = false,
}: IMainTextInputProps) {
  return (
    <InputTextContainer
      borderWidth={1}
      shadowOpacity={1}
      shadowRadius={1}
      shadowOffset={{ width: 2, height: 2 }}
      borderRadius={round ? 15 : 0}
      alignItems="center"
      variant="textInput"
    >
      <TextInput
        onChangeText={onTextChange}
        style={{ width: "100%" }}
        value={inputText}
        placeholder={placeholderTextInput}
        multiline={multiline}
        maxLength={maxLength}
      />
    </InputTextContainer>
  );
}

export { MainTextInput };
